export default {
  fontFamily: {
    properties: {
      component: 'FontFamily',
      type: "formatting",
      displayName: "Font family",
      description: null
    },
    value: null
  },
  fontFace: {
    properties: {
      component: 'FontFamily',
      type: "formatting",
      displayName: "Font family",
      description: null
    },
    value: null
  },
  goalFontFamily: {
    properties: {
      component: 'FontFamily',
      type: "formatting",
      displayName: "Goal Font family",
      description: null
    },
    value: null
  },
  distanceFontFamily: {
    properties: {
      component: 'FontFamily',
      type: "formatting",
      displayName: "Distance Font family",
      description: null
    },
    value: null
  },
  questionFontFamily: {
    properties: {
      component: 'FontFamily',
      type: "formatting",
      displayName: "Question font family",
      description: null
    },
    value: null
  },
  restatementFontFamily: {
    properties: {
      component: 'FontFamily',
      type: "formatting",
      displayName: "Restatement font family",
      description: null
    },
    value: null
  },
  headerFontFamily: {
    properties: {
      component: 'FontFamily',
      type: "formatting",
      displayName: "Header font family",
      description: null
    },
    value: null
  },
  cardFontFamily: {
    properties: {
      component: 'FontFamily',
      type: "formatting",
      displayName: "Card font family",
      description: null
    },
    value: null
  },
  dataLabelFontFamily: {
    properties: {
      component: 'FontFamily',
      type: "formatting",
      displayName: "Label Font family",
      description: null
    },
    value: "Verdana"
  },
  lastDateFontFamily: {
    properties: {
      component: 'FontFamily',
      type: "formatting",
      displayName: "Last date Font family",
      description: null
    },
    value: "Verdana"
  },
  titleFontFamily: {
    properties: {
      component: 'FontFamily',
      type: "formatting",
      visible: 'showAxisTitle',
      displayName: "Font family",
      description: null
    },
    value: null
  },
  categoryLabelFontFamily: {
    properties: {
      component: 'FontFamily',
      type: "formatting",
      displayName: "Label Font family",
      description: null
    },
    value: 13
  },
  secFontFamily: {
    properties: {
      component: 'FontFamily',
      type: "formatting",
      displayName: "Font family",
      description: null
    },
    value: null
  },
  levelTitleFontFamily: {
    properties: {
      component: 'FontFamily',
      type: "formatting",
      displayName: "Title Font Family",
      description: null
    },
    value: "ArialBlack"
  },
  levelSubtitleFontFamily: {
    properties: {
      component: 'FontFamily',
      type: "formatting",
      displayName: "Subtitle Font Family",
      description: null
    },
    value: "Arial"
  },
  secTitleFontFamily: {
    properties: {
      component: 'FontFamily',
      type: "formatting",
      displayName: "Font family",
      description: null
    },
    value: null
  },

}